import { Link } from "react-router-dom";

type Props = {
  deviceId: string;
  deviceUid: string;
  label?: string;
  className?: string;
};

export function DeviceLink({ deviceId, deviceUid, label, className }: Props) {
  const display = label?.trim() || deviceUid;
  const showUidTitle = Boolean(label?.trim() && label.trim() !== deviceUid);

  return (
    <Link
      to={`/devices/${deviceId}`}
      className={className}
      title={showUidTitle ? deviceUid : undefined}
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <span className="mono" style={{ fontSize: 12 }}>
        {display}
      </span>
    </Link>
  );
}
